import { Component, OnInit, Inject } from '@angular/core';
import { InterpretationService } from '../../interpretation.service';
import { NotificationsService } from 'angular2-notifications';
import { RecommendationTypeModel, AddRecommendationModel, UpdateRecommendationModel, RecommendationModel, SeverityTypeModel } from '../../models/interpretation.model';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'edit-recommendation',
  templateUrl: './edit-recommendation.component.html',
  styleUrls: ['./edit-recommendation.component.scss']
})
export class EditRecommendationComponent implements OnInit {
  inspectionId: number = -1;
  quoteId: number = -1;
  componentId: number = -1;
  recommendationId: number = -1;
  recommendation: RecommendationModel = new RecommendationModel();
  loading: boolean = true;

  loadingPossibleRecommendations: boolean = true;
  possibleRecommendations: RecommendationTypeModel[] = [];
  SeverityDropDownList: SeverityTypeModel[] = [];
  form: FormGroup;
  savingForm: boolean = false;
  severityId: number = 0;
  constructor(private _dialogRef: MatDialogRef<EditRecommendationComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _interp: InterpretationService,
    private _notify: NotificationsService,
    private _router: Router,
    private _fb: FormBuilder) { }

  ngOnInit() {
    this.inspectionId = this._data.inspectionId;
    this.quoteId = this._data.quoteId;
    this.componentId = this._data.componentId;
    this.recommendationId = this._data.recommendationId;
    this.severityId = this._data?.recommendationDetail?.SeverityId;
    this.getSeverityDropdown();
    this.loadRecommendation();
   
   
  }

  initializeForm() {
    var _SVT = this.SeverityDropDownList.find(x => x.Severitycategory == this.recommendation.Severitycategory);
    if (_SVT != null)
      this.severityId = _SVT.Id;

    this.form = this._fb.group({
      'smuToTakeAction': [this.recommendation.StartActionAtSmu, Validators.required],
      'smuToCompleteActionBy': [this.recommendation.CompleteActionBySmu - this.recommendation.StartActionAtSmu, Validators.required],
      'labourCost': [this.recommendation.LabourCost, Validators.required],
      'partsCost': [this.recommendation.PartsCost, Validators.required],
      'miscCost': [this.recommendation.MiscCost, Validators.required],
      'comment': [this.recommendation.Comment],
      'actionDate': [this.recommendation.ActionDate, Validators.required],
      'severityId':  [this.severityId, Validators.required]
    });
  }

  loadRecommendation() {
    this._interp.getRecommendation(this.inspectionId, this.recommendationId).subscribe(r => {
      this.recommendation = r;
      
      this.initializeForm();
      this.loading = false;
    }, err => {
      console.error(err);
      this._notify.error('Error', 'Failed to load quote details. Please contact TrackTreads support. ');
    });
  }

  closeModal() {
    this._dialogRef.close();
  }

  onSubmit(form) {
    if(!this.form.valid)
    {
      return;
    }

    if (form.recommendation < 1)
      return;
    this.savingForm = true;
    let rec = new UpdateRecommendationModel();
    rec.RecommendationId = this.recommendationId;
    rec.Comment = form.comment;
    rec.ComponentId = this.componentId;
    rec.InspectionId = this.inspectionId;
    rec.QuoteId = this.quoteId;
    rec.LabourCost = form.labourCost;
    rec.PartsCost = form.partsCost;
    rec.MiscCost = form.miscCost;
    rec.SmuToCompleteActionBy = form.smuToTakeAction + form.smuToCompleteActionBy;
    rec.SmuToTakeAction = form.smuToTakeAction;
    rec.ActionId = this.recommendation.ActionId;
    rec.ActionDate = form.actionDate;
    rec.severityId   = form.severityId;
    this._interp.updateRecommendation(rec).subscribe(r => {
      if (r.m_Item1 > 0) {
        this._notify.success('Added', r.m_Item2);
        this._router.navigate(['/interpretation/', this.inspectionId]);
        this._dialogRef.close(this.updateRecommendationModel(form));
      } else {
        this._notify.error('Failed', r.m_Item2);
        console.error(r.m_Item2);
   
      }
      this.savingForm = false;
    }, error => {
      this._notify.error('Error', 'Unable to update the recommendation. Please contact TrackTreads support. ');
      console.error(error);
      this.savingForm = false;
    });
  }

  updateRecommendationModel(formObject): RecommendationModel {
    this.recommendation.Comment = formObject.comment;
    this.recommendation.LabourCost = formObject.labourCost;
    this.recommendation.PartsCost = formObject.partsCost;
    this.recommendation.MiscCost = formObject.miscCost;
    this.recommendation.CompleteActionBySmu = formObject.smuToTakeAction + formObject.smuToCompleteActionBy;
    this.recommendation.StartActionAtSmu = formObject.smuToTakeAction;
    this.recommendation.ActionDate = formObject.actionDate;
    return this.recommendation;
  }

  getPossibleRecommendations() {
    this._interp.getPossibleRecommendations(this.inspectionId, this.componentId).subscribe(rec => {
      this.possibleRecommendations = rec;
      this.loadingPossibleRecommendations = false;
    }, err => {
      this._notify.error('Error', 'Unable to load possible recommendations. Please contact TrackTreads support. ');
      console.error(err);
    });
  }
  getSeverityDropdown() {
    this._interp.getSeverityDropdown(this.inspectionId).subscribe(rec => {
      this.SeverityDropDownList = rec;
      //this.recommendation = r;
      
      this.loadingPossibleRecommendations = false;
    }, err => {
      this._notify.error('Error', 'Unable to load possible recommendations. Please contact TrackTreads support. ');
      console.error(err);
    });
  }
}
